const serverApi = window.location.hostname
/**
 * 开发环境下的路由类型微应用注册，比如系统管理模块等
 * 生产环境下是根据后台接口动态加载注册
 * 无特殊情况，路由类型微应用渲染的container都是layout页面的#subapp-view
 * @Author: tanyc 
 * @Date: 2021-03-11 10:39:16 
 */
const apps = {
    sysman:{
        id: 'subapp-view-sysman',
        name: 'sysman',
        // entry: 'http://192.168.0.26:8301',
        entry: `http://${serverApi}:8501`,
        // entry: 'http://192.168.0.203:8015/sysman/',
        container: '#subapp-view-sysman',
        activeRule: '/sysman',
    },
    'competition':{
        id: 'subapp-view-competition',
        name: 'competition',
        // entry: 'http://192.168.0.203:8015/basedata',
        entry: `http://${serverApi}:8502`,
        container: '#subapp-view-competition',
        activeRule: '/competition'
    },
} as Record<string, any>

const microAppConfig = []

for(let i in apps){
    microAppConfig.push(apps[i])
}

export default apps;

export {
    microAppConfig
}